import { HR, Spacer } from "../Atoms"
import React, { FC, ReactNode } from "react"
import { H4 } from "@carrotfertility/carotene"

type RRHeaderWithHRProps = {
  children: ReactNode
}

/**
 * A Header element intended for composition within a RoundedRectangle
 */
const RRHeaderWithHR: FC<RRHeaderWithHRProps> = ({ children }) => (
  <>
    <H4 variant="dark">{children}</H4>
    <Spacer height={0.375} />
    <HR color="black-10" />
    <Spacer height={0.25} />
  </>
)

export { RRHeaderWithHR }
